import React from "react";
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';

function FormularyUploadProgress({ show, progress }) {
  const getProgressVariant = () => {
    if (progress?.status === 'Failed') return 'danger';
    if (progress?.status === 'Completed') return 'success';
    return 'primary';
  };

  const getProgressLabel = () => {
    if (!progress) return 'Initializing...';
    if (progress.status === 'Failed') return `Failed: ${progress.errorMessage}`;
    if (progress.status === 'Completed') return 'Upload Complete!';
    return `Processing: ${progress.percentComplete}%`;
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
    >    
      <Modal.Header>
        <Modal.Title>
          <h4 className="modal-title">
            <i className="fas fa-upload neo-primary"></i>&nbsp; Formulary Upload Progress
          </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <p className="mb-2">{getProgressLabel()}</p>
          {progress && progress.status === 'InProgress' && (
            <>
              <ProgressBar 
                now={progress.percentComplete} 
                label={`${progress.percentComplete}%`}
                variant={getProgressVariant()}
                animated
                striped
              />
              <small className="text-muted mt-2 d-block">
                Processed {progress.processedItems} of {progress.totalItems} items
              </small>
            </>
          )}
          {progress && progress.status === 'Completed' && (
            <ProgressBar 
              now={100} 
              label="100%"
              variant="success"
            />
          )}
          {progress && progress.status === 'Failed' && (
            <div className="alert alert-danger mt-2" role="alert">
              {progress.errorMessage}
            </div>
          )}
          {!progress && (
            <ProgressBar 
              now={100} 
              variant="primary"
              animated
              striped
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

FormularyUploadProgress.propTypes = {
  show: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    status: PropTypes.oneOf(['InProgress', 'Completed', 'Failed']),
    percentComplete: PropTypes.number,
    processedItems: PropTypes.number,
    totalItems: PropTypes.number,
    errorMessage: PropTypes.string,
  }),
};

export default FormularyUploadProgress;

